import loadable from "@loadable/component";
import CreateIcon from "../../../Icons/Create";
import APIS from "../../../constant/EndPoint";
import usePostHook from "../../../customHooks/usePostHook";

const CreateServiceTypeComponent = loadable(
  () => import("../../../components/Settings/ServiceType/CreateServiceType")
);
const CreateServiceType = () => {
  const { mutateAsync , isPostLoading } = usePostHook({
    queryKey: ["service-type"],
    navigateURL: "/service-type",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.SERVICE_TYPE}`;
    let formData = {
      ...values
     };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Service Type</span>
      </div>
      <CreateServiceTypeComponent
      isLoading={isPostLoading}
       handleCreate={handleCreate} 
       />
    </>
  );
};

export default CreateServiceType;
